import { TextareaAutosize } from "@material-ui/core"
import { swalWithConfirmAndCancelButtons } from "components/custom/swal"
import moment from "moment"
import React, { useEffect, useState } from "react"
import Loader from "react-loaders"
import { toast } from "react-toastify"
import { Col, Input, Label, Modal, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import colors from "utils/colors"
import isNullOrEmpty from "utils/isNullOrEmpty"

const EditScenarioRoleModal = ({
  isOpen,
  toggleModal,
  roleIdToEdit,
  reload,
}) => {
  const currentUser = userService.getLoggedInUser()
  const [roleToEdit, setRoleToEdit] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [hasNameError, setHasNameError] = useState(false)

  useEffect(() => {
    if (isOpen && roleIdToEdit !== undefined) {
      setHasNameError(false)
      loadData()
    }
  }, [isOpen, roleIdToEdit])

  const loadData = async () => {
    setIsLoading(true)

    let r = await api.getScenarioRole(roleIdToEdit, currentUser.enterpriseID)
    setRoleToEdit(r)

    setIsLoading(false)
  }

  const save = async () => {
    if (isNullOrEmpty(roleToEdit?.roleName)) {
      setHasNameError(true)
      return
    }

    if (roleToEdit.scenarioRoleID > -1) {
      await api.updateScenarioRole({
        ...roleToEdit,
        enterpriseID: currentUser.enterpriseID,
      })
      toast.success("Role updated successfully")
    } else {
      await api.createScenarioRole({
        ...roleToEdit,
        enterpriseID: currentUser.enterpriseID,
      })
      toast.success("Role created successfully")
    }

    toggleModal()
    reload && reload()
  }

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      size="xl"
      toggle={() => {
        toggleModal()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          {roleToEdit?.roleID > -1 ? "Edit Role" : "Add Role"}
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        {isLoading && (
          <Loader
            type="line-scale-pulse-out"
            color={colors.primary}
            style={{ textAlign: "center" }}
          />
        )}
        {!isLoading && (
          <>
            <div className="mb-3">
              <Label className="form-label">Name *</Label>
              <Input
                name="note"
                type="text"
                value={roleToEdit?.roleName}
                onChange={e => {
                  setRoleToEdit({
                    ...roleToEdit,
                    roleName: e.target.value,
                  })
                }}
              />
              {hasNameError && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  Role name is required.
                </div>
              )}
            </div>

            <Row>
              <Col md="4">
                <Label className="form-label">Menu Items</Label>
                <table
                  className="table table-bordered low-padding-table"
                  style={{ backgroundColor: "white" }}
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>Menu Item</th>
                      <th>Rights</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roleToEdit?.menuItems.map((menuItem, index) => (
                      <tr key={index}>
                        <td>
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            checked={menuItem.isSelected}
                            onClick={e => {
                              setRoleToEdit({
                                ...roleToEdit,
                                menuItems: roleToEdit.menuItems.map(item => {
                                  if (item.menuItemID == menuItem.menuItemID) {
                                    return {
                                      ...item,
                                      isSelected: !item.isSelected,
                                      menuItemRight: !item.isSelected
                                        ? "full"
                                        : "-1",
                                    }
                                  }
                                  return item
                                }),
                              })
                            }}
                          />
                        </td>
                        <td>
                          {!isNullOrEmpty(menuItem.parentName)
                            ? `${menuItem.parentName} - `
                            : ""}
                          {menuItem.name}
                        </td>
                        <td>
                          <select
                            className="form-control form-select select2 mb-xxl-0"
                            value={menuItem.menuItemRight}
                            onChange={e => {
                              setRoleToEdit({
                                ...roleToEdit,
                                menuItems: roleToEdit.menuItems.map(item => {
                                  if (item.menuItemID == menuItem.menuItemID) {
                                    return {
                                      ...item,
                                      menuItemRight: e.target.value,
                                      isSelected:
                                        e.target.value != "-1"
                                          ? true
                                          : item.isSelected,
                                    }
                                  }
                                  return item
                                }),
                              })
                            }}
                          >
                            <option value="-1">Select Right</option>
                            <option value="full">Full</option>
                            <option value="read only">Read Only</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
              <Col md="4">
                <Label className="form-label">Tabs</Label>
                <table
                  className="table table-bordered low-padding-table"
                  style={{ backgroundColor: "white" }}
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>Tab</th>
                      <th>Rights</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roleToEdit?.tabs.map((tab, index) => (
                      <tr key={index}>
                        <td>
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            checked={tab.isSelected}
                            onClick={e => {
                              setRoleToEdit({
                                ...roleToEdit,
                                tabs: roleToEdit.tabs.map(item => {
                                  if (item.tabID == tab.tabID) {
                                    return {
                                      ...item,
                                      isSelected: !item.isSelected,
                                      tabRight: !item.isSelected
                                        ? "full"
                                        : "-1",
                                    }
                                  }
                                  return item
                                }),
                              })
                            }}
                          />
                        </td>
                        <td>{tab.tabName}</td>
                        <td>
                          <select
                            className="form-control form-select select2 mb-xxl-0"
                            value={tab.tabRight}
                            onChange={e => {
                              setRoleToEdit({
                                ...roleToEdit,
                                tabs: roleToEdit.tabs.map(item => {
                                  if (item.tabID == tab.tabID) {
                                    return {
                                      ...item,
                                      tabRight: e.target.value,
                                      isSelected:
                                        e.target.value != "-1"
                                          ? true
                                          : item.isSelected,
                                    }
                                  }
                                  return item
                                }),
                              })
                            }}
                          >
                            <option value="-1">Select Right</option>
                            <option value="full">Full</option>
                            <option value="read only">Read Only</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
              <Col md="4">
                <Label className="form-label">Action Items</Label>
                <table
                  className="table table-bordered low-padding-table"
                  style={{ backgroundColor: "white" }}
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>Action Item</th>
                      <th>Rights</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roleToEdit?.actionItems.map((actionItem, index) => (
                      <tr key={index}>
                        <td>
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            checked={actionItem.isSelected}
                            onClick={e => {
                              setRoleToEdit({
                                ...roleToEdit,
                                actionItems: roleToEdit.actionItems.map(
                                  item => {
                                    if (
                                      item.actionItemID ==
                                      actionItem.actionItemID
                                    ) {
                                      return {
                                        ...item,
                                        isSelected: !item.isSelected,
                                        actionItemRight: !item.isSelected
                                          ? "full"
                                          : "-1",
                                      }
                                    }
                                    return item
                                  }
                                ),
                              })
                            }}
                          />
                        </td>
                        <td>{actionItem.actionItemName}</td>
                        <td>
                          <select
                            className="form-control form-select select2 mb-xxl-0"
                            value={actionItem.actionItemRight}
                            onChange={e => {
                              setRoleToEdit({
                                ...roleToEdit,
                                actionItems: roleToEdit.actionItems.map(
                                  item => {
                                    if (
                                      item.actionItemID ==
                                      actionItem.actionItemID
                                    ) {
                                      return {
                                        ...item,
                                        actionItemRight: e.target.value,
                                        isSelected:
                                          e.target.value != "-1"
                                            ? true
                                            : item.isSelected,
                                      }
                                    }
                                    return item
                                  }
                                ),
                              })
                            }}
                          >
                            <option value="-1">Select Right</option>
                            <option value="full">Full</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </Row>
          </>
        )}
      </div>

      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={toggleModal}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary save-user"
          onClick={save}
        >
          Save
        </button>
      </div>
    </Modal>
  )
}

export default EditScenarioRoleModal
